import React from 'react';
import PropTypes from 'prop-types';

// FontAwesome.
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

// Styled.
import * as S from './styled';

const Switch = ({ name, onClick, isActive, icon, disabled = false }) => (
  <S.Mode onClick={onClick} isActive={isActive} disabled={disabled}>
    <FontAwesomeIcon icon={icon} />
    <S.Label>{name}</S.Label>
  </S.Mode>
);

Switch.propTypes = {
  name: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  isActive: PropTypes.bool.isRequired,
  icon: PropTypes.object.isRequired,
  disabled: PropTypes.bool,
};

export default Switch;
